export default __webpack_public_path__ + "guide--raster-rasters-emspectrum-960-df43311ea7616d4f32559121bd091874.png";